<template>
    <div> 
        <div class="boxfil2">
            <div class="boxpago">
                <b-button variant="light" class="bt-pago" :disabled="pago">
                    <b-row>
                        <b-col>
                            <i class="fa fa-4x fa-chevron-circle-right text-dark"></i>
                            <!-- <i class="far fa-4x fa-money-bill-alt text-success"></i> -->
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            Pagar                 
                        </b-col>
                    </b-row>
                </b-button>
            </div>
            <div class="box2pago">
                <div class="boxboton">
                    <b-button variant="light" @click="calculadora(1)" class="bt-num">1</b-button>
                </div>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora(2)" class="bt-num">2</b-button>
                </div>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora(3)" class="bt-num">3</b-button>
                </div>
                <div class="boxboton">
                    <b-button variant="danger" @click="del()" class="bt-num"><i class="fa fa-backspace"></i></b-button>
                </div><br>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora(4)" class="bt-num">4</b-button>
                </div>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora(5)" class="bt-num">5</b-button>
                </div>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora(6)" class="bt-num">6</b-button>
                </div>
                 <div class="boxboton">
                    <b-button variant="danger" @click="clear()" class="bt-num"><i class="fas fa-eraser"></i></b-button>
                </div><br>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora(7)" class="bt-num">7</b-button>
                </div>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora(8)" class="bt-num">8</b-button>
                </div>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora(9)" class="bt-num">9</b-button>
                </div><br>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora(0)" class="bt-num cero">0</b-button>
                </div>
                <div class="boxboton">
                    <b-button variant="light"  @click="calculadora('.')" class="bt-num">.</b-button>
                </div>
            </div>  
        </div>
    </div>

</template>

<script>
    export default {
        name: 'CalculadorPagos',
        props:['pago'],
        data: () => {
            return {
                display: 0,
            }     
        },
    mounted(){
        this.$emit('numerohijo',this.display);
        },
    watch: {
        display(){
             this.$emit('numerohijo',this.display);
            },
        },
    methods:{
        calculadora(number){
            if(this.operatorClicked === true) {
                this.display = '';
                this.operatorClicked = false;
            }
            this.display =this.display === 0 ? (this.display = number): '' + this.display + number;   
        },
        del(){
            this.display = this.display.slice(0, -1)
        },
        clear(){
            this.display = 0;
        },
        }   
    }
</script>

<style lang="scss" scoped>
.boxfil2{
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: #efefef;
    width: 366px;
    height: 150px;
}
.boxcliente{
    display: inline-block;
    height: 37px;
    width: 150px;
}
.boxpago{
    float: left;
    display: inline-block;
    height: 150px;
    width: 150px;
}
.box2pago{
    margin-right: 2px;
    display: inline-block;
    height: 150px;
    float: right;
}
.boxboton{
    display: inline-block;
}
.bt-num{
    width: 50px;
    margin: 1px;
}
.bt-cliente{
    width: 152px;
}
.bt-pago{
    margin-top: 2px;
    margin-left: 2px;
    width: 152px;
    height: 144px;
}
.cero{
    width: 100px;
}
</style>